module.exports = __webpack_public_path__ + "static/media/QatamyaHeights.6ed44ad1.jpg";